import React, { useContext } from 'react'
import AlgoliaWrapper from 'components/AlgoliaWrapper/AlgoliaWrapper'
import { Configure } from 'react-instantsearch'
import ListingWrapper from './ListingWrapper/ListingWrapper'
import { SiteContext } from '@interflora/ui-components/build/utils/common'
import { useRouter } from 'next/router'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

interface Props {
  category?: {
    _meta: {
      deliveryKey: string
    }
    name: string
  }
}

const BlogArticleListing = (props: Props) => {
  const { category } = props
  const searchParameters = {
    filters: category ? `blogCategories:${category._meta.deliveryKey}` : '',
  }

  const { shorthand } = useContext(SiteContext)
  const router = useRouter()
  const page = router?.query?.page ? Math.max(0, parseInt(router.query.page.toString()) - 1) : undefined

  const indexName = `blog_article_${shorthand}_published_date_desc`
  useLoaded(props)

  return (
    <AlgoliaWrapper
      indexName={indexName}
      key={router?.query?.page?.toString()}
      initialUiState={{ [indexName]: { page } }}
    >
      <Configure
        hitsPerPage={12}
        distinct={true}
        {...(!category._meta.deliveryKey.startsWith('blog/all') && searchParameters)}
        page={page}
      />
      <ListingWrapper />
    </AlgoliaWrapper>
  )
}

export default BlogArticleListing
